import { render, staticRenderFns } from "./formContent.vue?vue&type=template&id=5252f4e7&scoped=true&"
import script from "./formContent.vue?vue&type=script&lang=js&"
export * from "./formContent.vue?vue&type=script&lang=js&"
import style0 from "./formContent.vue?vue&type=style&index=0&id=5252f4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252f4e7",
  null
  
)

export default component.exports